import { connect } from 'react-redux';
import { newPurchase, syncSeatsFromBus } from '@/actions/purchase';
import parseQueryString from 'utils/queryString/parseQueryString';
import parseJsonQueryParam from 'utils/queryString/parseJsonQueryParam';
import { getSeatsPurchasePayload, isSeatsOnResultActivated } from 'utils/seats';
import NewPurchase from './NewPurchase';

const mapStateToProps = (state) => ({
  purchase: state.purchase.toJS(),
  search: state.search.toJS(),
  frequentPassengers: state.userPreferences?.toJS()?.frequentPassengers?.passengers || [],
  features: state.whitelabelConfig?.features || {},
});

/**
 * Maps purchase actions to component props.
 * @param {Function} dispatch - Redux dispatch function.
 * @param {object} ownProps - Router props.
 * @returns {object} Purchase action props.
 */
const mapDispatchToProps = (dispatch, ownProps) => ({
  syncSeatsFromBus: () => {
    const { match } = ownProps;
    const { departureId, returnId } = match.params;
    dispatch(syncSeatsFromBus(departureId, returnId));
  },
  createPurchase: () => {
    const { location, match } = ownProps;
    const { departureId, returnId, passengers = 'A1' } = match.params;
    const {
      seenPrice,
      adAttribution = false,
      exchangeData = '',
      tripsInfo = '',
    } = parseQueryString(location.search);
    const exchangeDataParsed = parseJsonQueryParam(exchangeData, '');
    const parsedTripInfo = parseJsonQueryParam(tripsInfo);
    const selectedSeats =
      isSeatsOnResultActivated() && getSeatsPurchasePayload({ departureId, returnId });
    dispatch(
      newPurchase(
        departureId,
        returnId,
        passengers,
        seenPrice,
        adAttribution,
        Boolean(exchangeDataParsed),
        exchangeDataParsed,
        null,
        null,
        parsedTripInfo,
        selectedSeats,
      ),
    );
  },
  replaceUrl: (route) => ownProps.history.replace(route),
});

export { mapDispatchToProps };
export default connect(mapStateToProps, mapDispatchToProps)(NewPurchase);
